<template>
  <div>

    <div v-if="isScrolled9">
      <Header />
    </div>

    <div>

      <div class="head-height"></div>


      <!-- info-banner -->
      <div class="info-banner about-banner">
        <div class="img"><img src="https://www.yasubit.com//uploads/allimg/20210509/1-210509200Q3595.png" alt=""></div>
        <div class="tbox">
          <div class="timg"><img src="https://www.yasubit.com//uploads/allimg/20210509/1-210509200R5192.png" alt="">
          </div>
          <div class="ttbox">
            <h2 class="t1">{{$t('message.guestSurveyTitle')}}</h2>
            <!-- <div class="t2"></div> -->
          </div>
        </div>
      </div>

      <!-- 问卷调查 -->
      <div class="questionnaire">
        <div class="box">
          <div class="tips">{{$t('message.questionCount', { count: 10 })}}</div>
          <form class="form weuiform">
            <div class="qbox" id="qbox-1" v-for="(item, index) in attribute" :key="index">
              <h2 class="title">{{$t('message.' + item.attrName)}}</h2>
              <template v-if="item.attrInputType === 2">
                <span class="abox">
                  <textarea v-model="form[item.attrId]" :id="'attr_' + item.attrId" class="text" :placeholder="item.attrName === 'guestQ7' ? $t('message.guestQ7_placeholder') : $t('message.fillTextareaPlaceholder')"
                    :name="'attr_' + item.attrId"></textarea>
                </span>
              </template>
              <template v-else>
                <span class="abox" v-for="(ans, i) in item.attrValues" :key="i">
                  <input v-model="form[item.attrId]" type="radio" :id="'radio-' + item.attrId + '-' + i"
                    :value="$t('message.' + ans)"><label :for="'radio-' + item.attrId + '-' + i" class="radio-label"
                    style="margin-top: 15px;">{{$t('message.' + ans)}}</label>
                </span>
              </template>
            </div>
          </form>
          <div class="pageck">
            <button type="submit" class="btn trigger" @click="submitForm">{{$t('message.submit')}}</button>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import Header from "@/views/header.vue";
import axios from "axios";
import Footer from "@/views/footer.vue";
export default {
  components: {

    Header,
    Footer,

  },
  created() {
    document.title = this.$t('message.guestSurveyTitle');
    // this.getList(); // 移除接口调用
    this.getIp();
  },
  data() {
    return {
      isScrolled9: true,
      form: {
        "typeid": 85
      },
      // 多语言静态问卷数据，所有文本用key
      attribute: [
        {
          attrId: 25,
          attrName: 'guestQ1',
          attrInputType: 3,
          attrValues: ['guestQ1_option1', 'guestQ1_option2']
        },
        {
          attrId: 27,
          attrName: 'guestQ2',
          attrInputType: 3,
          attrValues: ['guestQ2_option1', 'guestQ2_option2', 'guestQ2_option3', 'guestQ2_option4']
        },
        {
          attrId: 29,
          attrName: 'guestQ3',
          attrInputType: 4,
          attrValues: ['guestQ3_option1', 'guestQ3_option2', 'guestQ3_option3', 'guestQ3_option4', 'guestQ3_option5', 'guestQ3_option6', 'guestQ3_option7']
        },
        {
          attrId: 31,
          attrName: 'guestQ4',
          attrInputType: 3,
          attrValues: ['guestQ4_option1', 'guestQ4_option2', 'guestQ4_option3', 'guestQ4_option4', 'guestQ4_option5']
        },
        {
          attrId: 33,
          attrName: 'guestQ5',
          attrInputType: 3,
          attrValues: ['guestQ5_option1', 'guestQ5_option2', 'guestQ5_option3', 'guestQ5_option4', 'guestQ5_option5']
        },
        {
          attrId: 35,
          attrName: 'guestQ6',
          attrInputType: 3,
          attrValues: ['guestQ6_option1', 'guestQ6_option2', 'guestQ6_option3', 'guestQ6_option4']
        },
        {
          attrId: 37,
          attrName: 'guestQ7',
          attrInputType: 2,
          attrValues: []
        },
        {
          attrId: 39,
          attrName: 'guestQ8',
          attrInputType: 3,
          attrValues: ['guestQ8_option1', 'guestQ8_option2', 'guestQ8_option3', 'guestQ8_option4']
        },
        {
          attrId: 41,
          attrName: 'guestQ9',
          attrInputType: 3,
          attrValues: ['guestQ9_option1', 'guestQ9_option2']
        },
        {
          attrId: 43,
          attrName: 'guestQ10',
          attrInputType: 2,
          attrValues: []
        }
      ],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        typeid: 85,
      },
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll9);
  },
  methods: {
    handleScroll9() {
      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;

      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false
        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true
        this.isScrolled9 = true;
      }
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      // // 当滚动距离小于等于200px时，设置isScrolled9为true
      // this.isScrolled9 = scrollDistance <=500;

    },
    getList() {
      // this.listArchives(this.queryParams)
      //   .then((response) => {
      //     this.attribute = response.rows;
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    submitForm() {
      if (Object.keys(this.form).length < 10) {
        this.$message.error(this.$t('message.fillAllQuestions'));
        return;
      }
      this.insertGuestbook(this.form).then((response) => {
        this.$message.success(this.$t('message.submitSuccess'));
        this.getList();
      });
    },
    insertGuestbook(data) {
      return axios
        .post("yasubit/guestbook/insert", data)
        //   .post("http://smartforet.cn:8080/yasubit/guestbook/insert", data)
        .then((response) => response.data);
    },
    listArchives(query) {
      return axios
        .get("yasubit/guestbook_attribute/list", {
          params: query,
        })
        //   .get("http://smartforet.cn:8080/yasubit/guestbook_attribute/list", {
        //     params: query,
        //   })
        .then((response) => response.data)
        .catch((error) => console.log(error));
    },
    getIp() {
      axios
        .get("https://api.ipify.org?format=json")
        .then((response) => {
          const ip = response.data.ip;
          this.form.ipAddress = ip;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>

<style>
.between {

  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center
}

.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width:1025px) {
  .info-banner .tbox .timg {
    margin-right: 30px;
  }
}
</style>
